import { GetAirCardsFunc, useSavedCardsQuery } from "entities/AirSavedCard";
import { AirSearchRequestFunc, useSearchQuery, UseSearchQueryReturnType } from "entities/AirSearchCard";
import { appStore } from "entities/App";
import { subscriptionStore } from "entities/Subscription";

type UseSearchReturnType = {
  getAirCards: GetAirCardsFunc;
  airSearchRequest: AirSearchRequestFunc;
  airSearchResponse: UseSearchQueryReturnType["searchResponse"];
  isAirSearchLoading: boolean;
  isAirSearchSuccess: boolean;
  isAirSearchError: boolean;
};

export const useAirSearch = ({ isAuthenticated }: { isAuthenticated: boolean }): UseSearchReturnType => {
  const { searchRequest, searchResponse, isSearchSuccess, isSearchError, isSearchLoading } = useSearchQuery({
    isAuthenticated,
    setSubscription: (subscription) => ({
      type: subscriptionStore.actions.setSubscription.type,
      payload: subscription,
    }),
    setActivePaymentModal: (activePaymentModal) => ({
      type: subscriptionStore.actions.setActivePaymentModal.type,
      payload: activePaymentModal,
    }),
    setAppIntegrationRequestLimitReached: (appIntegrationRequestLimitReached) => ({
      type: appStore.actions.setAppIntegrationRequestLimitReached.type,
      payload: appIntegrationRequestLimitReached,
    }),
    setWebAppRequestLimitReached: (webAppRequestLimitReached) => ({
      type: appStore.actions.setWebAppRequestLimitReached.type,
      payload: webAppRequestLimitReached,
    }),
  });
  const { getCards, isCardsLoading, isCardsSuccess, isCardsError } = useSavedCardsQuery({
    queryKey: ["checkAirSavedCardExisting"],
  });

  return {
    getAirCards: getCards,
    airSearchRequest: searchRequest,
    airSearchResponse: searchResponse,
    isAirSearchLoading: isSearchLoading || isCardsLoading,
    isAirSearchSuccess: isSearchSuccess || isCardsSuccess,
    isAirSearchError: isSearchError || isCardsError,
  };
};
